import React from 'react'

function Footer() {
    return (
        <div>
            <footer id="footer">
                <div className="row">
                    <div className="container">
                        <div className="copyright-container-wrap">
                            <p> © 2025 <a href="/"> Snapshot Videos </a> - All Rights Reserved.</p>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    )
}

export default Footer